import React from 'react'
import TransactionView from 'tennders-transactions/views/TransactionView'
import OrderDocumentModal from 'tennders-documents/modals/OrderDocumentModal'
import Toast from 'tennders-stracture/layouts/views/toast/Toast'
import Prompts from 'tennders-stracture/layouts/views/prompt/Prompts'
import MStatusChange from 'tennders-market/bin/modals/StatusChange'
import MStatusUpdateEmail from 'tennders-market/bin/modals/StatusUpdateEmail'
import MRequestUpdate from 'tennders-transactions/modal/MRequestUpdate'
import MAssignTo from 'tennders-market/bin/modals/AssignTo'
import MEDTUpdate from 'tennders-market/bin/modals/EdtUpdate'
import MEditTransaction from 'tennders-transactions/modal/MEditTransaction'
import MDeleteTransaction from 'tennders-transactions/modal/MDeleteTransaction'
import MSendCheckOffer from 'tennders-market/bin/modals/SendCheckOffer'
import DocView from 'tennders-documents/modals/DocView'
import GeneralLayoutTransaction from 'tennders-stracture/layouts/views/GeneralLayoutTransaction'
import GPopup from 'tennders-market/common/components/popup/GPopup'
import MCarrierCompanyFlow from 'tennders-company/add-edit/modal/CompanyFlowModal'
import InformativeModal from 'tennders-company/add-edit/modal/InformativeModal'
import WelcomeModal from 'tennders-company/add-edit/modal/WelcomeModal'
import ShareLoadBox from 'tennders-market/load/component/board/ShareLoadBox'
import CarrierShareBox from 'tennders-market/common/components/CarrierShareBox'
import MUpdatePaymentTerms from 'tennders-transactions/modal/MUpdatePaymentTerms'

const LayoutModals = () => (
  <>
    <Toast />
    <GPopup />
    <Prompts />
    <MStatusChange />
    <MStatusUpdateEmail />
    <MRequestUpdate />
    <MAssignTo />
    <MEDTUpdate />
    <MEditTransaction />
    <MDeleteTransaction />
    <MSendCheckOffer />
    <ShareLoadBox />
    <CarrierShareBox />
    <TransactionView />
    <OrderDocumentModal />
    <DocView />
    <GeneralLayoutTransaction />
    <MCarrierCompanyFlow />
    <InformativeModal />
    <WelcomeModal />
    <MUpdatePaymentTerms />
  </>
)

LayoutModals.displayName = 'LayoutModals'

export default React.memo(LayoutModals)
